module.exports = __webpack_public_path__ + "img/150-14.4fbe939e.jpg";